import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
type OfferModalProps = {
  isOpen: boolean;
  onClose: () => void;
};
export function OfferModal({
  isOpen,
  onClose
}: OfferModalProps) {
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-141">
      {isOpen && <motion.div className="fixed inset-0 z-50 flex items-center justify-center bg-[#2b1b15]/50 p-5" role="presentation" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} onMouseDown={onClose} data-id="element-142">
          <motion.section role="dialog" aria-modal="true" aria-labelledby="confirmation-title" className="relative w-full max-w-md rounded-[2rem] bg-[#fffaf0] p-8 text-center shadow-2xl" initial={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} onMouseDown={event => event.stopPropagation()} data-id="element-143">
            <button type="button" onClick={onClose} aria-label="Cerrar confirmación" className="absolute right-5 top-5 rounded-full p-2 text-[#6a584d] hover:bg-[#f1e7d8] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#a84b35]" data-id="element-144">
              <XIcon className="h-5 w-5" data-id="element-145" />
            </button>
            <CheckCircle2Icon className="mx-auto h-14 w-14 text-[#72846b]" aria-hidden="true" data-id="element-146" />
            <p className="mt-5 text-xs font-bold tracking-[0.18em] text-[#a84b35]" data-id="element-147">
              LISTA PARA TI
            </p>
            <h2 id="confirmation-title" className="mt-2 font-serif text-3xl text-[#3c2b23]" data-id="element-148">
              Tu guía te está esperando.
            </h2>
            <p className="mt-4 leading-7 text-[#6a584d]" data-id="element-149">
              Esta es una demostración de compra. En un checkout real recibirías
              acceso inmediato al PDF y tus tarjetas digitales.
            </p>
            <button type="button" onClick={onClose} className="mt-7 w-full rounded-full bg-[#3c2b23] px-5 py-3.5 font-bold text-white focus:outline-none focus-visible:ring-4 focus-visible:ring-[#3c2b23]/25" data-id="element-150">
              Entendido
            </button>
          </motion.section>
        </motion.div>}
    </AnimatePresence>;
}